import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../environments/environment";
import { timeout } from 'rxjs/operators';
import { BBFeature } from './BBFeature';

@Injectable()
export class AppService {

    constructor(private http: HttpClient) { }

    /**
     * It will refresh the toggle-able features from Azure app config service on start-up.
     * All of the features are stored in local storage and available from all accross UI modules.
     * 
     * @author Ayan Saha
     */
    refreshFeatures() {
        let serviceUrl = environment.BB_APIGATEWAY_SERVICE_URL + "features"
        let options = {}

        this.http.get<BBFeature>(serviceUrl, options)
            .pipe(timeout(environment.defaultTimeout))
            .subscribe({
                next: (results) => {
                    localStorage.setItem("features", JSON.stringify(results));

                }, error: (_errors) => {
                    console.log("Error while feating feature")
                }
            });
    }
}